var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("summary-section-layout", {
    attrs: {
      id: "other-properties",
      "section-title": _vm.$t(
        "application-standalone.pages.properties.propertiesYouOwn"
      ),
      "has-missing-information": _vm.hasMissingInformation,
    },
    on: {
      edit: function ($event) {
        return _vm.$emit("edit")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var applicant = ref.applicant
          return [
            !_vm.applicantHasOtherProperties(applicant["other-properties"])
              ? _c("p", { staticClass: "text-light-gray" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.pages.pleaseReviewThisSection"
                        )
                      ) +
                      "\n    "
                  ),
                ])
              : _vm._l(
                  applicant["other-properties"],
                  function (otherProperty, otherPropertyIndex) {
                    return _c(
                      "p",
                      { key: otherPropertyIndex, staticClass: "mb-2" },
                      [
                        _vm.otherPropertyFormattedAddress(otherProperty)
                          ? _c("span", [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.otherPropertyFormattedAddress(
                                      otherProperty
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ])
                          : _vm.hasMissingInformation
                          ? _c("span", { staticClass: "grey-text" }, [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.pages.pleaseReviewThisSection"
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }
                ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }